/*
 * export from pepperi-lib/core/common/model
 */
export * from './public-api';
